import StuckReasons from './StuckReasons'

export default StuckReasons
